import React from 'react'

import { TypographyV2 } from '../Seatbelt2/Foundations/Typography'

export const Typography = (props: Props) => <TypographyV2 {...props} />

///////// IMPLEMENTATION /////////

type Props = Parameters<typeof TypographyV2>[0]
